import React, { useContext } from "react";
import { AuthContext } from "../../../AppContext/AuthContext";
import { useNavigate } from "react-router-dom";
import { ProjectContext } from "../../../AppContext/ProjectContext";
import { useDeviceType } from "../../../Utils/useDeviceType";
import MobileviewV1 from "./Mobileview-v1";
import WebviewV2 from "./Webview-v2";
import { Stack } from "@mui/material";

export default function ProjectList({ projects = [] }) {
  const { userInfo } = useContext(AuthContext);
  const navigate = useNavigate();
  const { createOrLoadDiscussion } = useContext(ProjectContext);
  const { isMobile } = useDeviceType();

  const createOrLoadDiscussionCb = (each) => {
    createOrLoadDiscussion(
      navigate,
      `/project/${each.projectNumber}`,
      userInfo?.communityCode,
      each
    );
  };

  const Component = isMobile ? MobileviewV1 : WebviewV2;

  return (
    <Stack spacing={0}>
      {projects.map((each) => (
        <Component
          key={each.id || each.projectNumber}
          each={each}
          createOrLoadDiscussionCb={createOrLoadDiscussionCb}
        />
      ))}
    </Stack>
  );
}
